import React from 'react';
import image from 'assets/images/icon-ia-whatsapp.png';

export const PromptHeader = () => {
	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
			<img src={image} alt="Configuração da IA de Atendimento" />
			<div>
				<h2 className='mb-0'>Configuração da IA de Atendimento</h2>
				<p className='mb-0'>Configure como a IA deve atuar nos atendimentos da sua empresa </p>
			</div>
		</div>
	);
};

export default PromptHeader;
